<app-ai-assistant-button
	*ngIf="router.url !== '/ai-chat' && !router.url.includes('/authentication/login')"
></app-ai-assistant-button>
<router-outlet></router-outlet>
<ng-template #customLoadingTemplate>
	<div class="custom-backdrop"></div>
</ng-template>
<ngx-loading [show]="loading" [template]="customLoadingTemplate"></ngx-loading>
